import { ChevronRight } from 'lucide-react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/shared/components/shadcn/breadcrumb';
import { cn } from '@/shared/utils/cn';

export interface BreadcrumbSegment {
  label: string;
  className?: string;
}

interface Props {
  segments: BreadcrumbSegment[];
  className?: string;
}

export function FilterBreadcrumb({ segments, className }: Props) {
  if (segments.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList className="flex-wrap">
        {segments.map((segment, index) => {
          const isLast = index === segments.length - 1;

          return (
            <span key={index} className="contents">
              <BreadcrumbItem>
                <span className={cn('text-muted-foreground', segment.className)}>
                  {segment.label}
                </span>
              </BreadcrumbItem>
              {!isLast && (
                <BreadcrumbSeparator>
                  <ChevronRight className="size-4" />
                </BreadcrumbSeparator>
              )}
            </span>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
